import { render, staticRenderFns } from "./BankAccountForm.vue?vue&type=template&id=92833966&scoped=true&"
import script from "./BankAccountForm.vue?vue&type=script&lang=js&"
export * from "./BankAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountForm.vue?vue&type=style&index=0&id=92833966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92833966",
  null
  
)

export default component.exports